import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { StarRatingModule } from 'ionic5-star-rating';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { SharedDirectiveModule } from '@app/shared/directives/shared-directive.module';
import { AboutUserComponent } from './about-user.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StarRatingModule,
    PipesModule,
    SharedDirectiveModule
  ],
  declarations: [AboutUserComponent],
  exports: [AboutUserComponent]
})
export class AboutUserModule { }
